<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-pen.png" alt width="27.3" height="27.3" />
      <p class="title-bk">ブランド編集</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: id ? 'brand-id-detail' : 'brand-detail', params: id ? { id } : {} }">
        戻る
      </router-link>
    </div>
    <div class="container">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(confirmChanged)" ref="form">
          <table class="table table-form">
            <tbody>
              <tr>
                <th scope="row">法人名（法人ID）</th>
                <td />
                <td>{{ currentCorporationDisplay }}</td>
              </tr>
              <tr>
                <th scope="row">ブランド名（ブランドID）</th>
                <td />
                <td>{{ currentBrandDisplay }}</td>
              </tr>
              <PasswordField vid="password" v-model="password" extraRules="required" />
              <PasswordField
                v-model="verifyPassword"
                extraRules="required|verify_password:password"
                label="パスワード（確認）"
              />
            </tbody>
          </table>
          <div class="text-center">
            <button type="submit" class="btn-red">実行</button>
          </div>
        </form>
      </ValidationObserver>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="ブランド情報に戻る"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header>ブランド情報</template>
        <template v-slot:body>パスワードの変更が完了しました</template>
      </PopUpHolder>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import store from '@/store/index.js';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import { ValidationObserver } from 'vee-validate';
import PasswordField from '@/components/forms/PasswordField.vue';
import { basicCorporationNameIdPresent, basicBrandNameIdPresent } from '@/presenters/fields';

export default {
  props: {
    id: {
      type: [String, Number],
      required: false,
    },
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('brand/fetchBrand', routeTo.params.id).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  components: {
    ValidationObserver,
    PasswordField,
    PopUpHolder,
  },
  data() {
    return {
      password: '',
      verifyPassword: '',
    };
  },
  computed: {
    currentBrand() {
      return this.brand.brand;
    },
    currentCorporationDisplay() {
      return basicCorporationNameIdPresent(this.currentBrand.corporation);
    },
    currentBrandDisplay() {
      return basicBrandNameIdPresent(this.currentBrand);
    },
    ...mapState(['brand']),
  },
  methods: {
    confirmChanged() {
      let payload = {
        id: this.currentBrand.id,
        password: this.password,
      };
      this.changeBrandPassword(payload).then(() => {
        this.$logger.debug('Show success popup');
        this.$refs['popup_holder'].show();
      });
    },
    popupConfirmed() {
      this.$logger.debug('Popup done');
      if (this.id) {
        // This path is for TIE and Corporation Role
        this.$logger.debug('Password Changed for ID: ' + this.id);
        this.$router.push({ name: 'brand-id-detail', params: { id: this.id } });
      } else {
        // This path is for Corporation Role
        this.$logger.debug('Password Changed');
        this.$router.push({ name: 'brand-detail' });
      }
    },
    ...mapActions('brand', ['changeBrandPassword']),
  },
};
</script>

<style scoped>
.btn-red {
  margin-left: 0px;
}
</style>
